// extracted by mini-css-extract-plugin
module.exports = {"bottomSection":"_2Hbm-rWt","section":"_1eo3LgMk"};